// src/components/PlantForm.tsx
// This file now imports the modular PlantForm component
import PlantForm from './PlantForm/index';
export default PlantForm;
